export default __webpack_public_path__ + "static/media/gdn.b46425c9.png";